export default __webpack_public_path__ + "2bf82cfe55023cf52cb5d3fc8c92b9cd.png";